import { IconDeviceComputerCamera, IconVideoPlus } from "@tabler/icons-react";

export const HiraCamera = () => {
  return (
    <div className="h-48 flex items-center justify-center border rounded-md bg-zinc-800">
      <IconDeviceComputerCamera size={48} className="opacity-10" />
    </div>
  );
};
